import subscribeModal from '../modules/subscribeModal';
import subscriberCookie from '../modules/subscriberCookie';

export default {
  teaser: null,
  teaserAccept: null,
  teaserDecline: null,
  teaserHiddenFlag: 'subscribe-teaser--hidden',
  cookieName: 'subscribeTeaserDisabled',

  _bindEvents() {
    if(this.teaserDecline) {
      this.teaserDecline.addEventListener( 'click', e => {
        this.hide();
        if(this.teaserPromoLink) {
          subscriberCookie.setNoInterest('drElseyPromoV1');
        } else {
          subscriberCookie.setNoInterest('drElseySubscriberV1');
        }
      });
    }

    if(this.teaserAccept) {
      this.teaserAccept.addEventListener('click', e => {
        this.hide();
        subscribeModal.show();
      });
    }
  },

  init() {
    this.teaser = document.querySelector('#subscribe-teaser');
    if ( !this.teaser ) return;

    this.teaserAccept = document.querySelector('#subscribe-teaser-accept');
    this.teaserDecline = document.querySelector('#subscribe-teaser-decline');
    this.teaserPromoLink = document.querySelector('#subscribe-teaser-promo-link');

    if(this.viewingPromoLink()) {
      subscriberCookie.setViewedPromoLink();
    }

    if (!this.shouldntShow()) {
      setTimeout( () => this.show(), 2000 );
    }

    this._bindEvents();
  },

  hide() {
    this.teaser.classList.add(this.teaserHiddenFlag);
  },

  show() {
    this.teaser.classList.remove(this.teaserHiddenFlag);
  },

  setNoShowCookie() {
    subscriberCookie.set('noInterest');
  },

  shouldntShow() {
    if(this.teaserPromoLink) {
      return subscriberCookie.exists('drElseyPromoV1');
    } else {
      return subscriberCookie.exists('drElseySubscriberV1');
    }
  },

  viewingPromoLink() {
    if(this.teaserPromoLink) {
      return (window.location.href === this.teaserPromoLink.href);
    } else {
      return false;
    }
  },
}
